define('modules/page_listing/views/search_tagcloud',['require','exports','module','base/collectionview','../models/tag','../collections/tags','./search_tagcloud_item','lib/util','ldsh!../templates/search_tagcloud'],function(require,exports,module){
  "use strict";
  
  var CollectionView = require("base/collectionview"),
      Tag = require("../models/tag"),
      TagCollection = require("../collections/tags"),
      ItemView = require("./search_tagcloud_item"),
      util = require("lib/util");

  var Controller = {
    removeTagOnDelete: true,
    addTag: function(tag) {
      if (!tag) return;
      var existingTag = this.collection.searchTag(tag.get("text"));
      if (!existingTag) {
        this.collection.add(tag.clone());
      }
    },
    removeTag: function(view, nop, tag) {
      this.collection.remove(tag);
    },
    removeLastTag: function() {
      if (this.removeTagOnDelete) {
        this.collection.pop();
      }
    },
    composeQuery: function() {
      return this.collection.toQueryString();
    },
  };

  module.exports = CollectionView.extend({
    template: require("ldsh!../templates/search_tagcloud"),
    className: "ed-tag-cloud",
    itemView: ItemView,
    itemContainer: ".js-tags",
    initialize: function(options){
      this.collection = this.collection || new TagCollection();
      this.listenTo(this.childVent, "tag:delete", this.removeTag);
      this.listenTo(this.collection, "add remove", this.toggleButton);
      this.isButtonHidden = options.buttonHidden;
    },
    toggleButton: function() {
      this.$("button").toggleClass("hidden", this.isButtonHidden || !this.collection.length);
    },
    onRender: function() {
      this.toggleButton();
    }
  });

  util.mixin(module.exports, Controller);
});

